import { Observer } from "mobx-react-lite";
import React from "react";
import { useControllers } from "../../hooks/controller.hooks";
import { useMakeFocusable } from "../../hooks/useMakeFocusable.hook";
import { useObservableRef } from "../../hooks/useObservableRef.hook";
import Overlay from "./Overlay";
export var OverlayStack = function (props) {
    var UI = useControllers().UI;
    var OVERLAY = UI.OVERLAY;
    var ref = useObservableRef();
    useMakeFocusable(ref, '.Overlay');
    return React.createElement(Observer, { children: function () {
            return UI.PORTAL.render(React.createElement("div", { className: "OverlayStack", ref: ref }, OVERLAY.overlays.map(function (o, i) { return React.createElement(Overlay, { overlay: o, key: o.id, index: i }); })));
        } });
};
export default OverlayStack;
